import React, {useEffect, useState, useContext} from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Select, { SelectOption } from "@amzn/meridian/select";
import Input from "@amzn/meridian/input"
import Text from "@amzn/meridian/text"
import Button from "@amzn/meridian/button";
import Alert from "@amzn/meridian/alert"
import axios from "axios";
import {getErrorAlertObjectFromResponse, getHeadersForNFMS, getNFMSEndpoint, getNodeId} from "../../Utils";
import {fetchAllPrograms, fetchFeaturesForProgram} from "../../NetworkUtils";
import {ALERT_TYPES} from "../../Constants";
import PageHeader from "../util/PageHeader";
import {NO_PERMISSION_ERROR, PAGE_HEADERS} from "../util/RouteConstants";
import {getUserLogin, PermissionsContext} from "../permissions/PermissionContext";
import ErrorPage from "../error/ErrorPage";


const EnableProgram = () => {
    // Checking editor permission
    const {canEnableProgram} = useContext(PermissionsContext);
    if (canEnableProgram === false) {
        return <ErrorPage errorTitle="Something went wrong" errorMessage={NO_PERMISSION_ERROR} />;
    }

    const [programName, setProgramName] = useState();
    const [isNumeric, setIsNumeric] = useState(false);
    const [mcmId, setMcmId] = useState();
    const [numericValue, setNumericValue] = useState();
    const [alert, setAlert] = useState({visible: false, text:"", type:""})
    const [programList, setProgramList] = useState([]);
    const warningAlert = {visible: true, text: "Enable Program request received.", type:ALERT_TYPES.WARNING};
    const successAlert = {visible: true, text: "Successfully enabled Program", type:ALERT_TYPES.SUCCESS};

    useEffect(() => {
        fetchAllPrograms().then(response => setProgramList(response))
    }, []);

    const programOnChange = (programName) => {
        /*
        * On change of select dropdown of programs, we are getting features of the program
        * If feature has numeric attribute then we will show numeric value input
        * */
        clearData();
        setProgramName(programName)
        if(programName) {
            fetchFeaturesForProgram(programName
            ).then(response => {
                if(response) {
                    setIsNumeric(response.some(feature => feature.isNumeric))
                }
            });
        }

    }

    const nodeId = getNodeId();
    function enableProgram () {
        setAlert(warningAlert);
        const params = { program: programName, nodeId: nodeId, mcmId: mcmId};
        if (numericValue && isNumeric) {
            // We only want to send numeric value if we have numeric config and numeric value is entered
            params.numericValue = parseInt(numericValue, 10)
        }
        (async ()=>{
            const headers  = await getHeadersForNFMS("EnableProgram");
            const userAlias = await getUserLogin();
            params.userAlias = userAlias;
            axios
                .post(getNFMSEndpoint(), params, headers)
                .then((response) => {
                    if (response.status === 200 && response.data.isSuccess === true) {
                        setAlert(successAlert);
                    }
                })
                .catch((response) => {
                    setAlert(getErrorAlertObjectFromResponse(response));
                })
        })();
    }

    const clearData = () => {
        setIsNumeric(false);
        setNumericValue(null);
    }

    return (
        <div className="App">
            <Column spacingInset={"small large"}>
                <Row widths={["grid-12"]} alignmentVertical="top" >
                    <PageHeader {...PAGE_HEADERS.ENABLE_PROGRAM} />
                </Row>
                <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                    <Column spacing="200" alignmentHorizontal="left">
                        <Text type="b200" color="secondary">
                            <FormattedMessage id="enableProgram.programName" defaultMessage="Program Name"/>
                        </Text>
                        <Select value={programName} onChange={programOnChange} placeholder="Select Program Name" width={400}>
                            {programList.map(program => (
                                <SelectOption label={program} value={program} key={program} />
                            ))}
                        </Select>
                    </Column>
                </Row>

                <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                    <Column spacing="200" alignmentHorizontal="left">
                        <Text type="b200" color="secondary">
                            <FormattedMessage id="enableProgram.mcm" defaultMessage="MCM Id"/>
                        </Text>
                        <Input id="mcm-input" value={mcmId} onChange={setMcmId} type="text" placeholder="Enter MCM Id" width={400}/>
                    </Column>
                </Row>

                <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                    <Column spacing="200" alignmentHorizontal="left">
                        <Text type="b200" color="secondary">
                            <FormattedMessage id="enableProgram.nodeId" defaultMessage="Node Id"/>
                        </Text>
                        <Input id="nodeId-input" disabled={true} value={nodeId} type="text" width={400}/>
                    </Column>
                </Row>

                { isNumeric &&
                    <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                    <Column spacing="200" alignmentHorizontal="left">
                        <Text type="b200" color="secondary">
                            <FormattedMessage id="enableProgram.numericValue" defaultMessage="Numeric Value"/>
                        </Text>
                        <Input id="numericValue-input" value={numericValue} onChange={setNumericValue} type="text"  placeholder="Enter Numeric Value" width={400}/>
                    </Column>
                </Row>
                }

                <Row alignmentVertical="top" spacingInset="large large large none">
                    <Button onClick={() => enableProgram()}>
                        <FormattedMessage id="enableProgram.enable" defaultMessage="Enable Program"/>
                    </Button>
                </Row>
                <Row alignmentVertical="top" spacingInset="none none medium none">
                    {alert.visible ? <Alert type={alert.type}>{alert.text}</Alert> : null}
                </Row>
            </Column>
        </div>
    );
}

export default injectIntl(EnableProgram);




// WEBPACK FOOTER //
// ./src/components/enable-program/EnableProgram.js